import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { useSelector } from "react-redux";
import { BoardCollectionHeader } from "~/components/BoardCollection/BoardCollectionHeader";
import { BoardCollectionOnboardingView } from "~/components/BoardCollection/BoardCollectionOnboardingView";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { boardCollectionViewSelector } from "~/store/boardCollection/selectors";
import { BoardCollectionGalleryView } from "./BoardCollectionGalleryView";
import { BoardCollectionSuccessState } from "./BoardCollectionSuccessState";
const UnsubmittedView = /*#__PURE__*/ memo((param)=>{
    let { isEmpty, scrollElementRef } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex min-h-full w-full flex-col md:flex-row",
        style: {
            height: isEmpty ? "100%" : "auto"
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mb-2 max-h-full flex-1 overflow-auto px-3 pb-4 pt-6 md:pb-12 md:pl-12",
                children: /*#__PURE__*/ _jsx(BoardCollectionHeader, {})
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "max-h-full flex-3 overflow-y-auto overflow-x-hidden px-3 md:pr-12",
                children: /*#__PURE__*/ _jsx(BoardCollectionGalleryView, {
                    scrollElementRef: scrollElementRef
                })
            })
        ]
    });
});
UnsubmittedView.displayName = "UnsubmittedView";
const SubmittedView = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsx(BoardCollectionSuccessState, {});
});
SubmittedView.displayName = "SubmittedView";
export const BoardCollectionViewWrapper = /*#__PURE__*/ memo((param)=>{
    let { isEmpty, scrollElementRef } = param;
    const { contentCollection } = useTemporaryFeatureFlags();
    const view = useSelector(boardCollectionViewSelector);
    switch(view){
        case "completed":
            return /*#__PURE__*/ _jsx(SubmittedView, {});
        case "manage":
            return /*#__PURE__*/ _jsx(UnsubmittedView, {
                scrollElementRef: scrollElementRef,
                isEmpty: isEmpty
            });
        case "onboarding":
        default:
            if (contentCollection) return /*#__PURE__*/ _jsx(BoardCollectionOnboardingView, {});
            return /*#__PURE__*/ _jsx(UnsubmittedView, {
                scrollElementRef: scrollElementRef,
                isEmpty: isEmpty
            });
    }
});
BoardCollectionViewWrapper.displayName = "BoardCollectionViewWrapper";
